import memoizeOne from 'memoize-one';
import { components as defaultComponents, type Components } from '../../components';

// Default any components not provided by the consumer using the standard ones.
export default memoizeOne((customComponents: Partial<Components>) => {
	const safeComponents = { ...defaultComponents, ...customComponents };

	return {
		List: safeComponents.List,
		Chart: safeComponents.Chart,
		listComponents: {
			ListItem: safeComponents.ListItem,
			ListItemContent: safeComponents.ListItemContent,
			ListItemContentTooltip: safeComponents.ListItemContentTooltip,
			NoMatches: safeComponents.NoMatches,
			Loader: safeComponents.Loader,
			IssueTitle: safeComponents.IssueTitle,
		},
		chartComponents: {
			ChartItem: safeComponents.ChartItem,
			Bar: safeComponents.Bar,
			ChartOverlay: safeComponents.ChartOverlay,
			Legend: safeComponents.Legend,
			ChartIndicators: safeComponents.ChartIndicators,
		},
	};
});
